import React, {useEffect, useState} from 'react';
import {useTranslation} from 'react-i18next';
import Button from '../../components/button';
import Input from '../../components/input';
import {
	deleteApplicationAccess,
	getApplicationAccess,
	isAddingNewKey as setIsAddingNewKey,
	postApplicationAccess
} from '../../../actions/applicationAccessActions';
import {useDispatch, useSelector} from 'react-redux';
import Loader from '../../components/sprite/components/loader';
import Icon from '../../components/icon';
import PicButton from '../../components/pic-button';
import {isUpgradeToBusinessPopup} from '../../../actions/popupActions';
import {sharingPageReady} from '../../../actions/profileActions';
import AccessDeniedPage from '../../components/access-denied-page';
import './index.css';

function APIKey () {

	const { t } = useTranslation();
	const [keyName, setKeyName] = useState("");

	const applicationAccess = useSelector( state => state.applicationAccessReducer.getApplicationAccess);
	const isAddingNewKey = useSelector( state => state.applicationAccessReducer.isAddingNewKey);
	const language = useSelector( state => state.languageReducer.language);
	const hasDeveloperApiPermission = useSelector( state => state.permissionReducer.hasDeveloperApiPermission);
	const profile = useSelector( state => state.profileReducer.getProfile);

	const dispatch = useDispatch();

	const cancelHandler = () => {
		dispatch(setIsAddingNewKey(false));
	};

	const newKeyHandler = () => {
		if(!hasDeveloperApiPermission) {
			dispatch(isUpgradeToBusinessPopup(true));
			return;
		}
		dispatch(setIsAddingNewKey(true));
	};

	useEffect(() => {
		dispatch(getApplicationAccess());
		dispatch(sharingPageReady(true));
	}, [dispatch]);

	const postKeyHandler = (e) => {
		e.preventDefault();
		dispatch(postApplicationAccess(keyName));
	};

	const keyNameInputHandler = (e) => {
		setKeyName(e.target.value.trim());
	};

	const deleteKeyHandler = (name) => {
		dispatch(deleteApplicationAccess(name));
	};

	if (profile.role === "ADMINISTRATOR") {
		return (
			<div className="application-access container mt-5">
				<h2>{t('apiKeyTitle')}</h2>
				{
					!isAddingNewKey
						?
						<div className="row">
							<div className="col">
								{
									applicationAccess
										?
										applicationAccess.applicationAccess.length > 0
											?
											<table className="table table-striped table-hover mb-5">
												<thead>
												<tr>
													<th scope="col">AccountId</th>
													<th scope="col">Name</th>
													<th scope="col">Key</th>
													<th scope="col"></th>
												</tr>
												</thead>
												<tbody>
												{
													applicationAccess.applicationAccess.map( (item, index) => (
														<tr key={index}>
															<th className="font-weight-normal" scope="row">{item.accountId}</th>
															<td>{item.name}</td>
															<td>{item.secret}</td>
															<td className="text-right">
																<PicButton onClick={() => deleteKeyHandler(item.name)}>
																	<Icon name="trash-o"/>
																</PicButton>
															</td>
														</tr>
													))
												}
												</tbody>
											</table>
											:
											<span className="mr-3">
											No secret key created
										</span>
										:
										<span className="mr-3">
										<Loader/>
									</span>
								}
								<Button className="btn-primary" onClick={newKeyHandler}>{t('apiKeyCreateNewKeyBtn')}</Button>
							</div>

						</div>
						:
						<form className="d-md-flex" onSubmit={postKeyHandler}>
							<div className="d-md-flex align-items-center">
								<label className="text-nowrap m-md-0 mr-2" htmlFor="keyNameInput">{t('apiKeyNameOfTheKeyLabel')}{language === 'fr' ? ' ' : ''}:</label>
								<Input className="mx-md-3" type="text" id="keyNameInput" onChange={keyNameInputHandler}/>
							</div>
							<div className="text-right mt-3 mt-md-0">
								<Button type="submit" disabled={!keyName} className="btn-primary mr-3">{t('textSave')}</Button>
								<Button type="button" className="btn-outline-primary" onClick={cancelHandler}>{t('textCancel')}</Button>
							</div>
						</form>
				}
			</div>
		)
	} else {
		return (
			<AccessDeniedPage/>
		)
	}


}

export default APIKey;
